import React, { useState, useEffect } from "react";
import ApiClient from "../services/api-client";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStore from "../hooks/useStore";

export default function TemplateSearch() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const company = useStore.getState().selectedCompany;
        ApiClient.getCompanyBranchesFull(company.id).then(
            response => {
                setBranches(response.data);
                setLoading(false);
            },
            error => {
                toast.error("Error: " + error.data);
                setLoading(false);
            }
        );
    }, []);

    const editTemplateSetting = (e, element) => {
        e.preventDefault();
        navigate("/designer/" + element.branch.id);
    };

    return (
        <div className="container template-search-container">

            {/* Header */}
            <div className="template-search-header">
                <div className="template-search-header-icon">
                    <i className="fa fa-file-text-o"></i>
                </div>
                <h4 className="template-search-title">{t("templateSearchInfo")}</h4>
                <p className="template-search-subtitle">{t("templateSearchSubtitle")}</p>
            </div>

            {/* Cards grid */}
            {loading ? (
                <div className="template-search-empty">
                    <i className="fa fa-spinner fa-spin fa-2x" style={{ color: 'var(--appcolor)', opacity: 0.5 }}></i>
                </div>
            ) : branches.length === 0 ? (
                <div className="template-search-empty">
                    <i className="fa fa-file-o fa-3x"></i>
                    <p>{t("noResults")}</p>
                </div>
            ) : (
                <div className="row g-3">
                    {branches.map(element => (
                        <div className="col-xl-3 col-lg-4 col-md-6" key={element.branch.id}>
                            <div className="template-card">
                                <div className="template-card-preview">
                                    {element.templateSettings?.logo ? (
                                        <img
                                            src={element.templateSettings.logo + "?" + element.branch.id}
                                            alt={element.branch.name}
                                            className="template-card-logo"
                                        />
                                    ) : (
                                        <div className="template-card-logo-placeholder">
                                            <i className="fa fa-image"></i>
                                            <span>{t("noLogo")}</span>
                                        </div>
                                    )}
                                </div>
                                <div className="template-card-info">
                                    <div className="template-card-name">{element.branch.name}</div>
                                    {element.branch.address && (
                                        <div className="template-card-address">
                                            <i className="fa fa-map-marker" style={{ marginRight: 5 }}></i>
                                            {element.branch.address}
                                        </div>
                                    )}
                                </div>
                                <div className="template-card-footer">
                                    <button
                                        onClick={e => editTemplateSetting(e, element)}
                                        className="btn btn-skin w-100"
                                    >
                                        <i className="fa fa-pencil" style={{ marginRight: 7 }}></i>
                                        {t("editTemplate")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
